export class ChannelDataModel {

    LastChannelUpdatedAt: string;
    ChannelType: string;
    IsChannelActive: boolean;
    ChannelId: string;
    EntityId: string;
    UserId: string;


    constructor(lastChannelUpdatedAt: string, channelType: string,isChannelActive: boolean,
        channelId: string,entityId:string,userId:string) {
        this.LastChannelUpdatedAt = lastChannelUpdatedAt;
        this.ChannelType = channelType;
        this.IsChannelActive = isChannelActive;
        this.ChannelId = channelId;
        this.EntityId = entityId;
        this.UserId = userId;

    }
}
